import { useState } from "react";
import { useTranslation } from "../../../context/TranslationContext";
import StepPhone from "./RegisterSteps/StepPhone";
import StepOtp from "./RegisterSteps/StepOtp";
import StepUserInfo from "./RegisterSteps/StepUserInfo";

const RegisterForm = ({ onBackToLogin, checkLogin }) => {
  const { backToLogin, register: registerTitle } = useTranslation();
  const [step, setStep] = useState(1); // 1: Phone, 2: OTP, 3: Personal Info
  const [regData, setRegData] = useState({
    phoneNumber: "",
    token: "",
  });

  const handleStep1Next = (phoneNumber) => {
    setRegData({ ...regData, phoneNumber });
    setStep(2);
  };

  const handleStep2Next = (token) => {
    setRegData({ ...regData, token });
    setStep(3);
  };

  const handleBackToLogin = () => {
    onBackToLogin();
  };

  return (
    <div className="w-full">
      <div className="flex items-center mb-6">
        <button
          onClick={handleBackToLogin}
          className="text-product-type-color text-sm font-semibold flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          {backToLogin}
        </button>
      </div>

      <h3 className="font-bold text-xl mb-6 text-[#333738]">{registerTitle}</h3>

      {step === 1 && <StepPhone onNext={handleStep1Next} />}

      {step === 2 && (
        <StepOtp phoneNumber={regData.phoneNumber} onNext={handleStep2Next} />
      )}

      {step === 3 && (
        <StepUserInfo token={regData.token} checkLogin={checkLogin} />
      )}
    </div>
  );
};

export default RegisterForm;
